import { ILocationSpecifiable, instanceOfILocationSpecifiable } from "./ILocationSpecifiable";
import { ISizeSpecifiable, instanceOfISizeSpecifiable } from "./ISizeSpecifiable";

export interface IRectangleCoordinatable<T = number> extends ILocationSpecifiable<T>, ISizeSpecifiable<T> {}

export function instanceOfIRectangleCoordinatable<T = number>(instance: any): instance is IRectangleCoordinatable<T> {
  return instanceOfILocationSpecifiable(instance)
      && instanceOfISizeSpecifiable(instance);
}
